import { api } from './_apiInterface';
import { pointer } from 'src/app-config';
import { typeCartAssignment, typeCartParticipant, typeCartPeriod, typeCartPoint, typeCartsDoc } from '@monorepo/models';

class CartServices {
    private Base = pointer.cart;
    //
    AddAssignment = async (assignment: typeCartAssignment) => {
        const data = await api.SendRequest(`${this.Base}/assignment`, 'POST', { assignment });
        return data;
    }
    AddAssignments = async (assignments: typeCartAssignment[]) => {
        const data = await api.SendRequest(`${this.Base}/assignment`, 'POST', { assignments });
        return data;
    }
    AddEnabledPeriod = async (point: typeCartPoint, period: typeCartPeriod) => {
        const data = await api.SendRequest(`${this.Base}/period`, 'POST', { period, point });
        return data;
    }
    AddParticipant = async (participant: typeCartParticipant) => {
        const data = await api.SendRequest(`${this.Base}/participant`, 'POST', { participant });
        return data;
    }
    AddPoint = async (point: typeCartPoint) => {
        const data = await api.SendRequest(`${this.Base}/point`, 'POST', { point });
        return data;
    }
    DeleteAssignment = async (assignment: typeCartAssignment) => {
        const data = await api.SendRequest(`${this.Base}/assignment`, 'DELETE', { assignment });
        return data;
    }
    DeleteEnabledPeriod = async (point: typeCartPoint, period: typeCartPeriod) => {
        const data = await api.SendRequest(`${this.Base}/period`, 'DELETE', { period, point });
        return data;
    }
    DeleteParticipant = async (participant: typeCartParticipant) => {
        const data = await api.SendRequest(`${this.Base}/participant`, 'DELETE', { participant });
        return data;
    }
    DeletePoint = async (point: typeCartPoint) => {
        const data = await api.SendRequest(`${this.Base}/point`, 'DELETE', { point });
        return data;
    }
    Get = async () => {
        const data = await api.SendRequest<{ cartsDoc: typeCartsDoc; }>(this.Base, 'GET');
        return data;
    }
    GetFree = async (congregation: number) => {
        const data = await api.SendRequest<{ cartsDoc: typeCartsDoc; }>(`${this.Base}?congregation=${congregation}`, 'GET');
        return data;
    }
    UpdateParticipant = async (participant: typeCartParticipant) => {
        const data = await api.SendRequest(`${this.Base}/participant`, 'PUT', { participant });
        return data;
    }
    UpdatePoint = async (point: typeCartPoint) => {
        const data = await api.SendRequest(`${this.Base}/point`, 'PUT', { point });
        return data;
    }
}

export const cartServices = new CartServices();
